import axios from "axios";
import Vue from "vue";
export const state = {
  drivers: [],
  vehicles: [],
  distances: [],
  requisitions: [],
  students: {},
  all_distances: {},
  save_status: false,
};
export const getters = {
  Vehicles: (state) => state.vehicles.data,
  Distances: (state) => state.distances.data,
  Students: (state) => state.students.data,
  AllDistances: (state) => state.all_distances,
  Drivers: (state) => state.drivers.data,
  Requisitions: (state) => state.requisitions.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_DRIVERS(state, newValue) {
    state.drivers = newValue;
  },
  SET_VEHICLES(state, newValue) {
    state.vehicles = newValue;
  },
  SET_DISTANCES(state, newValue) {
    state.distances = newValue;
  },
  SET_ALL_DISTANCES(state, newValue) {
    state.all_distances = newValue;
  },
  SET_STUDENTS(state, newValue) {
    state.students = newValue;
  },
  SET_REQUISITIONS(state, newValue) {
    state.requisitions = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  addDistance({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("distances", payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Distance Was Saved Successfully",
        };
        commit("pushNotification", message);
        dispatch("fetchDistances");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While adding",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Edit Staff Distance
  editDistance({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`distances/${payload.id}`, payload)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Distance Was updated Successfully",
        };
        commit("pushNotification", message);
        dispatch("fetchDistances");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While editing",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  // Delete Staff Distance
  deleteDistance({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`distances/${payload.id}`)
      .then(() => {
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Distance Was deleted Successfully",
        };
        commit("pushNotification", message);
        dispatch("fetchDistances");
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While deleting",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addDriver({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("drivers", payload)
      .then(() => {
        dispatch("fetchDrivers");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "Driver Was Saved Successfully",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Driver
  editDriver({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`drivers/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchDrivers");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Driver ${payload.name} Was Edited Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Driver",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Driver
  deleteDriver({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`drivers/${payload.id}`)
      .then(() => {
        dispatch("fetchDrivers");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Driver ${payload.name} Was Deleted Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Staff",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addVehicle({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("vehicles", payload)
      .then(() => {
        dispatch("fetchVehicles");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Vehicle with plate ${payload.plate} Was Saved Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Vehicle
  editVehicle({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`vehicles/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchVehicles");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Vehicle ${payload.plate} Was Edited Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Vehicle",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Vehicle
  deleteVehicle({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`vehicles/${payload.id}`)
      .then(() => {
        dispatch("fetchVehicles");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Vehicle ${payload.name} Was Deleted Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Staff",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },
  saveDistance({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`save_distance`, payload)
      .then(() => {
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  addRequisition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("vehicle_requisitions", payload)
      .then(() => {
        dispatch("fetchRequisitions");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Requisition Was Saved Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Saving Requisition",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Edit Vehicle
  editRequisition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .put(`vehicle_requisitions/${payload.id}`, payload)
      .then(() => {
        dispatch("fetchRequisitions");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Requisition Was Edited Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Editing Requisition",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  // Delete Vehicle
  deleteRequisition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`vehicle_requisitions/${payload.id}`)
      .then(() => {
        dispatch("fetchRequisitions");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Requisition has been deleted Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While Deleting Staff",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  approveRequisition({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("approve_vehicle_requisition", payload)
      .then(() => {
        dispatch("fetchRequisitions");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Requisition Was approved Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While approving Requisition",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  taken({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("vehicle_taken", payload)
      .then(() => {
        dispatch("fetchRequisitions");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: `Vehicle marked ad taken Successfully`,
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      })
      .catch(() => {
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While changing Requisition Status",
        };
        commit("pushNotification", message);
        commit("SET_SAVE_STATUS", false);
      });
  },

  fetchDistances({ commit }) {
    axios.get(`distances`).then((res) => {
      commit("SET_DISTANCES", res.data);
    });
  },
  fetchAllDistances({ commit }) {
    axios.get(`getdistances`).then((res) => {
      commit("SET_ALL_DISTANCES", res.data);
    });
  },
  fetchVehicles({ commit }) {
    axios.get(`vehicles`).then((sta) => {
      commit("SET_VEHICLES", sta.data);
    });
  },
  fetchDrivers({ commit }) {
    axios.get(`drivers`).then((sta) => {
      commit("SET_DRIVERS", sta.data);
    });
  },
  fetchStudents({ commit }) {
    axios.post(`student_distances`).then((sta) => {
      commit("SET_STUDENTS", sta.data);
    });
  },
  fetchRequisitions({ commit }) {
    axios.get(`vehicle_requisitions`).then((sta) => {
      commit("SET_REQUISITIONS", sta.data);
    });
  },
};
